export const environment = {
    production: false,
    url: 'https://dev.api.sensors.smog.datatask.net',
};
